import script from "./EditStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditStep.vue?vue&type=script&lang=ts&setup=true"

import "./EditStep.vue?vue&type=style&index=0&id=6a2ee4ac&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2ee4ac"]])

export default __exports__